// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 540px) {
  .menu ion-icon {
    font-size: 10vw;
    cursor: pointer;
    color: #414042;
  }
  h1 {
    font-size: 7vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: left;
  }
  .sidebar2 {
    width: 100%;
    background-color: #dfebf2;
    border-radius: 1vw;
    padding: 1vw;
  }
  .sidebar2 h1 {
    font-size: 4.5vw;
    cursor: pointer;
  }
  .sidebar2 h2 {
    color: #5e5d59;
    font-size: 3vw;
    font-weight: bold;
  }
  .sidebar2 p {
    color: #0038a8;
    font-size: 4vw;
  }
  .sidebar2 ion-icon {
    color: #5e5d59;
    font-size: 4.5vw;
  }
  .content-text {
    line-height: 8vw;
  }
}
@media (min-width: 720px) {
  .menu ion-icon {
    font-size: 8vw;
    cursor: pointer;
    color: #414042;
  }
  h1 {
    font-size: 4vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: left;
  }
  .sidebar2 {
    width: 100%;
    background-color: #dfebf2;
    border-radius: 1vw;
    padding: 1vw;
  }
  .sidebar2 h1 {
    font-size: 1vw;
    cursor: pointer;
  }
  .sidebar2 h1 ion-icon {
    font-size: 4vw;
  }
  .sidebar2 h2 {
    color: #5e5d59;
    font-size: 3vw;
    font-weight: bold;
  }
  .sidebar2 p {
    color: #0038a8;
    font-size: 3vw;
  }
  .sidebar2 ion-icon {
    color: #5e5d59;
    font-size: 3vw;
  }
  .content-text {
    line-height: 4.5vw;
    font-size: 3vw;
  }
}
@media (min-width: 960px) {
  .logo {
    width: 133px;
    height: 72px;
    background-image: url('logo.svg');
    background-size: 100%;
  }
  .menu ion-icon {
    font-size: 2vw;
    cursor: pointer;
    color: #414042;
  }
  h1 {
    font-size: 2vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: left;
  }
  .sidebar2 {
    width: 100%;
    background-color: #dfebf2;
    border-radius: 0.5vw;
    padding: 1vw;
  }
  .sidebar2 h1 {
    font-size: 1vw;
    cursor: pointer;
  }
  .sidebar2 h1 ion-icon {
    font-size: 1.2vw;
  }
  .sidebar2 h2 {
    color: #5e5d59;
    font-size: 1.1vw;
    font-weight: bold;
  }
  .sidebar2 p {
    color: #0038a8;
    font-size: 0.9vw;
  }
  .sidebar2 ion-icon {
    color: #5e5d59;
    font-size: 1.1vw;
  }
  .content-text {
    line-height: 1.5vw;
    font-size: 1vw;
  }
}
.bg {
  background-image: url('student-bg.svg');
  background-repeat: no-repeat;
  background-color: #f0f6f9;
  background-position-y: bottom;
}

.content {
  background-color: white;
  background-image: url('student-bg-bottom.svg');
  background-repeat: no-repeat;
  background-position: center bottom;
  border-top-left-radius: 1vw;
  border-top-right-radius: 1vw;
  margin-top: -1vw;
  min-height: 100vh;
}

ion-content {
  --ion-background-color: #dfebf2;
}

ion-select,
ion-select-option {
  font-family: "Otomanopee One", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/student/module-popover/module-popover.page.scss"],"names":[],"mappings":"AAAA;EACE;IACE,eAAA;IACA,eAAA;IACA,cAAA;EACF;EACA;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,gBAAA;EACF;EAEA;IACE,WAAA;IACA,yBAAA;IACA,kBAAA;IACA,YAAA;EAAF;EAGA;IACE,gBAAA;IACA,eAAA;EADF;EAIA;IACE,cAAA;IACA,cAAA;IACA,iBAAA;EAFF;EAIA;IACE,cAAA;IACA,cAAA;EAFF;EAIA;IACE,cAAA;IACA,gBAAA;EAFF;EAIA;IACE,gBAAA;EAFF;AACF;AAKA;EACE;IACE,cAAA;IACA,eAAA;IACA,cAAA;EAHF;EAKA;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,gBAAA;EAHF;EAKA;IACE,WAAA;IACA,yBAAA;IACA,kBAAA;IACA,YAAA;EAHF;EAMA;IACE,cAAA;IACA,eAAA;EAJF;EAMA;IACE,cAAA;EAJF;EAMA;IACE,cAAA;IACA,cAAA;IACA,iBAAA;EAJF;EAMA;IACE,cAAA;IACA,cAAA;EAJF;EAMA;IACE,cAAA;IACA,cAAA;EAJF;EAMA;IACE,kBAAA;IACA,cAAA;EAJF;AACF;AAOA;EACE;IACE,YAAA;IACA,YAAA;IACA,iCAAA;IACA,qBAAA;EALF;EAQA;IACE,cAAA;IACA,eAAA;IACA,cAAA;EANF;EAQA;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,gBAAA;EANF;EASA;IACE,WAAA;IACA,yBAAA;IACA,oBAAA;IACA,YAAA;EAPF;EAUA;IACE,cAAA;IACA,eAAA;EARF;EAUA;IACE,gBAAA;EARF;EAUA;IACE,cAAA;IACA,gBAAA;IACA,iBAAA;EARF;EAUA;IACE,cAAA;IACA,gBAAA;EARF;EAUA;IACE,cAAA;IACA,gBAAA;EARF;EAUA;IACE,kBAAA;IACA,cAAA;EARF;AACF;AAWA;EACE,uCAAA;EACA,4BAAA;EACA,yBAAA;EACA,6BAAA;AATF;;AAYA;EACE,uBAAA;EACA,8CAAA;EACA,4BAAA;EACA,kCAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;AATF;;AAYA;EACE,+BAAA;AATF;;AAYA;;EAEE,yCAAA;AATF","sourcesContent":["@media (max-width: 540px) {\r\n  .menu ion-icon {\r\n    font-size: 10vw;\r\n    cursor: pointer;\r\n    color: #414042;\r\n  }\r\n  h1 {\r\n    font-size: 7vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: left;\r\n  }\r\n\r\n  .sidebar2 {\r\n    width: 100%;\r\n    background-color: #dfebf2;\r\n    border-radius: 1vw;\r\n    padding: 1vw;\r\n  }\r\n\r\n  .sidebar2 h1 {\r\n    font-size: 4.5vw;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .sidebar2 h2 {\r\n    color: #5e5d59;\r\n    font-size: 3vw;\r\n    font-weight: bold;\r\n  }\r\n  .sidebar2 p {\r\n    color: #0038a8;\r\n    font-size: 4vw;\r\n  }\r\n  .sidebar2 ion-icon {\r\n    color: #5e5d59;\r\n    font-size: 4.5vw;\r\n  }\r\n  .content-text {\r\n    line-height: 8vw;\r\n  }\r\n}\r\n\r\n@media (min-width: 720px) {\r\n  .menu ion-icon {\r\n    font-size: 8vw;\r\n    cursor: pointer;\r\n    color: #414042;\r\n  }\r\n  h1 {\r\n    font-size: 4vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: left;\r\n  }\r\n  .sidebar2 {\r\n    width: 100%;\r\n    background-color: #dfebf2;\r\n    border-radius: 1vw;\r\n    padding: 1vw;\r\n  }\r\n\r\n  .sidebar2 h1 {\r\n    font-size: 1vw;\r\n    cursor: pointer;\r\n  }\r\n  .sidebar2 h1 ion-icon {\r\n    font-size: 4vw;\r\n  }\r\n  .sidebar2 h2 {\r\n    color: #5e5d59;\r\n    font-size: 3vw;\r\n    font-weight: bold;\r\n  }\r\n  .sidebar2 p {\r\n    color: #0038a8;\r\n    font-size: 3vw;\r\n  }\r\n  .sidebar2 ion-icon {\r\n    color: #5e5d59;\r\n    font-size: 3vw;\r\n  }\r\n  .content-text {\r\n    line-height: 4.5vw;\r\n    font-size: 3vw;\r\n  }\r\n}\r\n\r\n@media (min-width: 960px) {\r\n  .logo {\r\n    width: 133px;\r\n    height: 72px;\r\n    background-image: url(\"../../../../assets/img/layout/logo.svg\");\r\n    background-size: 100%;\r\n  }\r\n\r\n  .menu ion-icon {\r\n    font-size: 2vw;\r\n    cursor: pointer;\r\n    color: #414042;\r\n  }\r\n  h1 {\r\n    font-size: 2vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: left;\r\n  }\r\n\r\n  .sidebar2 {\r\n    width: 100%;\r\n    background-color: #dfebf2;\r\n    border-radius: 0.5vw;\r\n    padding: 1vw;\r\n  }\r\n\r\n  .sidebar2 h1 {\r\n    font-size: 1vw;\r\n    cursor: pointer;\r\n  }\r\n  .sidebar2 h1 ion-icon {\r\n    font-size: 1.2vw;\r\n  }\r\n  .sidebar2 h2 {\r\n    color: #5e5d59;\r\n    font-size: 1.1vw;\r\n    font-weight: bold;\r\n  }\r\n  .sidebar2 p {\r\n    color: #0038a8;\r\n    font-size: 0.9vw;\r\n  }\r\n  .sidebar2 ion-icon {\r\n    color: #5e5d59;\r\n    font-size: 1.1vw;\r\n  }\r\n  .content-text {\r\n    line-height: 1.5vw;\r\n    font-size: 1vw;\r\n  }\r\n}\r\n\r\n.bg {\r\n  background-image: url(\"../../../../assets/img/layout/student-bg.svg\");\r\n  background-repeat: no-repeat;\r\n  background-color: #f0f6f9;\r\n  background-position-y: bottom;\r\n}\r\n\r\n.content {\r\n  background-color: white;\r\n  background-image: url(\"../../../../assets/img/layout/student-bg-bottom.svg\");\r\n  background-repeat: no-repeat;\r\n  background-position: center bottom;\r\n  border-top-left-radius: 1vw;\r\n  border-top-right-radius: 1vw;\r\n  margin-top: -1vw;\r\n  min-height: 100vh;\r\n}\r\n\r\nion-content {\r\n  --ion-background-color: #dfebf2;\r\n}\r\n\r\nion-select,\r\nion-select-option {\r\n  font-family: \"Otomanopee One\", sans-serif;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
